import { render, staticRenderFns } from "./importacao.vue?vue&type=template&id=7b07da3e&scoped=true&"
import script from "./importacao.vue?vue&type=script&lang=js&"
export * from "./importacao.vue?vue&type=script&lang=js&"
import style0 from "./importacao.vue?vue&type=style&index=0&id=7b07da3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07da3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
